module.exports = __webpack_public_path__ + "static/mountainintereiors-7d15c61f9d06fa55ebd8fd4804fffc78.jpg";